import React from "react";

export default (props: React.SVGAttributes<SVGElement>) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M5 13L12 2L19 13L12.75 13L12.75 22L11.25 22L11.25 13L5 13Z" fill="black"/>
    </svg>
)
